import { BAILocale } from '.';
import fr_FR from 'antd/es/locale/fr_FR';

const localeValue: BAILocale = {
  lang: 'fr',
  antdLocale: fr_FR,
};

export default localeValue;
